import { render, staticRenderFns } from "./FillingDetailsEdit.vue?vue&type=template&id=620c1bb9"
import script from "./FillingDetailsEdit.vue?vue&type=script&lang=js"
export * from "./FillingDetailsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports